import {client} from './services/client'

export  const ask_payouts = {
    namespaced:true,
    state:{
        ask_payouts:[],
        ask_payoutsep:[],
        ask_payoutsap:[],
        ask_payoutsef:[],
        ask_payoutsa:[],
        ask_payoutse:[],
        ask_payoutsen:[],
        askcancelloading:true,
        askententeloading:true,
        askdoloading:true,
    },
    mutations: {
        SET_ASKPAYOUT (state,ask_payouts){
            state.ask_payouts = ask_payouts
        },
        SET_ASKPAYOUTEP (state,ask_payoutsep){
            state.ask_payoutsep = ask_payoutsep
        },
        SET_ASKPAYOUTAP (state,ask_payoutsap){
            state.ask_payoutsap = ask_payoutsap
        },
        SET_ASKPAYOUTEF (state,ask_payoutsef){
            state.ask_payoutsef = ask_payoutsef
        },
        SET_ASKPAYOUTA (state,ask_payoutsa){
            state.ask_payoutsa = ask_payoutsa
        },
        SET_ASKPAYOUTE (state,ask_payoutse){
            state.ask_payoutse = ask_payoutse
        },
        SET_ASKPAYOUTEN (state,ask_payoutsen){
            state.ask_payoutsen = ask_payoutsen
        },
        SET_ASKCANCELLOADING (state,ask_payoutsen){
            state.askcancelloading = ask_payoutsen
        },
        SET_ASKENTENTELOADING (state,ask_payoutsen){
            state.askententeloading = ask_payoutsen
        },
        SET_ASKDOLOADING (state,ask_payoutsen){
            state.askdoloading = ask_payoutsen
        },


    },
    actions: {
        getAsk_payoutOne({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/ask_payout/getOne/'+id,
                })
                    .then((response)=>{
                        let ask_payouts = response.data.ask_payouts;
                        console.log(ask_payouts);
                        commit('SET_ASKPAYOUT',ask_payouts)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getAsk_payoutOneE({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/ask_payout/getOneE/'+id,
                })
                    .then((response)=>{
                        let ask_payoutsep = response.data.ask_payoutsep;
                        console.log(ask_payoutsep);
                        commit('SET_ASKPAYOUTEP',ask_payoutsep)
                        commit('SET_ASKENTENTELOADING',false)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getAsk_payoutOneEF({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/ask_payout/getOneEF/'+id,
                })
                    .then((response)=>{
                        let ask_payoutsef = response.data.ask_payoutsef;
                        console.log(ask_payoutsef);
                        commit('SET_ASKPAYOUTEF',ask_payoutsef)
                        commit('SET_ASKDOLOADING',false)


                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getAsk_payoutOneA({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/ask_payout/getOneA/'+id,
                })
                    .then((response)=>{
                        let ask_payoutsap = response.data.ask_payoutsap;
                        console.log(ask_payoutsap);
                        commit('SET_ASKPAYOUTAP',ask_payoutsap)
                        commit('SET_ASKCANCELLOADING',false)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getAsk_payoutEnattente({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/ask_payout/en_attente',
                })
                    .then((response)=>{
                        let ask_payoutsen = response.data.ask_payoutsen;
                        console.log(ask_payoutsen);
                        commit('SET_ASKPAYOUTEN',ask_payoutsen)
                        commit('SET_ASKENTENTELOADING',false)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getAsk_payoutEffectuer({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/ask_payout/effectuer',
                })
                    .then((response)=>{
                        let ask_payoutse = response.data.ask_payoutse;
                        console.log(ask_payoutse);
                        commit('SET_ASKPAYOUTE',ask_payoutse)
                        commit('SET_ASKDOLOADING',false)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getAsk_payoutAnnuler({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/ask_payout/annuler',
                })
                    .then((response)=>{
                        let ask_payoutsa = response.data.ask_payoutsa;
                        console.log(ask_payoutsa);
                        commit('SET_ASKPAYOUTA',ask_payoutsa)
                        commit('SET_ASKCANCELLOADING',false)
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        setAsk_payout({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/ask_payout/save',
                    data:data,
                })
                    .then((response)=>{
                        let ask_payoutsep = response.data.ask_payoutsep;
                        commit('SET_ASKPAYOUTEP',ask_payoutsep);

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        etatAsk_payout({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/ask_payout/etat/'+data.id+'/'+data.state_ask,
                })
                    .then((response)=>{
                        let ask_payouts = response.data.ask_payouts;
                        commit('SET_ASKPAYOUT',ask_payouts);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
        commentAsk_payout({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/ask_payout/comment',
                    data:data,
                }).then((response)=>{
                    let ask_payouts = response.data.ask_payouts;
                    commit('SET_ASKPAYOUT',ask_payouts);

                    resolve(response);
                })
                    .catch((error)=>{
                        reject(error);
                    })
            })
        },
        annuleAsk_payout({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/ask_payout/annule/'+id,
                })
                    .then((response)=>{
                        let ask_payouts = response.data.ask_payouts;
                        commit('SET_ASKPAYOUT',ask_payouts);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getAsk_payoutOneE: state  => {
            return state.ask_payoutsep
        },
        getAsk_payoutOne: state  => {
            return state.ask_payouts
        },
        getAsk_payoutOneEF: state  => {
            return state.ask_payoutsef
        },
        getAsk_payoutOneA: state  => {
            return state.ask_payoutsap
        },
    }
};
